/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

export const barWidthThreshold = 2;
export const maxBarWidth = 30;
export const minBarWidth = 5;
